export default __webpack_public_path__ + "static/media/arrows-rotate-solid.7b9e2d5d.svg";